/** Original crown-V brand mark for Concept 4 Crimson Noir — not third-party art. */
export function BrandMark({ size = 28 }: { size?: number }) {
  return (
    <svg
      className="brand-mark"
      width={size}
      height={size}
      viewBox="0 0 48 48"
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        <linearGradient id="vbbMarkBg" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#ff2d35" />
          <stop offset="55%" stopColor="#e31e24" />
          <stop offset="100%" stopColor="#7a0f14" />
        </linearGradient>
        <linearGradient id="vbbMarkGold" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#f0d78c" />
          <stop offset="100%" stopColor="#b8922a" />
        </linearGradient>
      </defs>
      <rect x="1" y="1" width="46" height="46" rx="12" fill="url(#vbbMarkBg)" />
      <rect x="3" y="3" width="42" height="42" rx="10" fill="none" stroke="rgba(255,255,255,0.12)" strokeWidth="1" />
      <path
        d="M12 15 L18 9 L24 15 L30 9 L36 15 L32.5 22 H15.5 Z"
        fill="url(#vbbMarkGold)"
      />
      <path
        d="M15 24 L24 12.5 L33 24 L29.5 36 H18.5 Z"
        fill="#ffffff"
      />
      <path d="M24 18 L27.5 24 H20.5 Z" fill="#e31e24" opacity="0.9" />
    </svg>
  );
}
